import React from 'react';
import Dropdown from './Dropdown';

const MultiSelect = (props) => {
    return (
        <Dropdown {...props} isMulti={true} />
    );
}

export default MultiSelect;